export default __webpack_public_path__ + "static/media/tabula-mobile-5.a68fb14a.png";